import { render, staticRenderFns } from "./DashboardSet.vue?vue&type=template&id=15d6e422&scoped=true&"
import script from "./DashboardSet.vue?vue&type=script&lang=js&"
export * from "./DashboardSet.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSet.vue?vue&type=style&index=0&id=15d6e422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d6e422",
  null
  
)

export default component.exports